var TABS_BLOCKS_REGEX = /<div\s+tabs\s*?(name=('|").+('|"))?\s*?>(.|\n)*?<\/div>/g; // Regex for removing blank lines for correct parsing toggle in ReactMarkdown component

var BLANK_LINES_REGEX = /^\s*$(?:\r\n?|\n)/gm;
export var removeBlankLines = function removeBlankLines(source) {
  return source.replace(BLANK_LINES_REGEX, "");
};
export var removeBlankLinesFromTabsBlock = function removeBlankLinesFromTabsBlock(_a) {
  var source = _a.source;

  var fn = function fn(str) {
    return str.replace(TABS_BLOCKS_REGEX, function (occurrence) {
      return removeBlankLines(occurrence);
    });
  };

  return fn(source.content || source.rawContent);
};